import * as React from 'react';
import { parse } from 'query-string';
import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux/index';
import * as FormulaStore from '@/redux/pages/formula';
import * as ProductEditStore from '@/redux/pages/product-edit';

export default class SelectManufacturer extends React.Component<any, any> {
    // 页码
    private page: number = 1;
    // 是否加载中
    private isLoading: boolean = true; // 是否加载中
    // 定时器
    private loadTimer: any;
    constructor(props: any) {
        super(props);
        this.state = {
            type: Number(parse(this.props.location.search).type || 1), // 1 产品 2 配方
            list: [], // 列表
            keyword: '', // 关键词
            loadOver: false, // 是否全部加载完
        };
    }

    public componentDidMount() {
        this.getData();
        window.addEventListener('scroll', this.scrollAction.bind(this));
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
        if (this.loadTimer) { 
            clearTimeout(this.loadTimer);
        }
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }

    public render() {
        const state = this.state;
        return(
            <section className="select-physical">
                <div className="ylk-search">
                    <div className="ylk-search-group">
                        <img src={require('../../../../assets/images/icon-search.png')} alt="" />
                        <input type="text" placeholder="名称、牌号、生产商" value={state.keyword} onChange={() => this.searchAction()}
                            onKeyDown={() => this.searchKeyDownAction()} />
                        <i className="search-clear" onClick={() => this.resetAction()}>&times;</i>
                    </div>
                    <button onClick={() => this.searchStartAction()}>搜索</button>
                </div>
                <div className="select-list">
                    {
                        state.list.map((v: any) => { 
                            return (
                                <p key={v.companyId} onClick={() => this.selectAction(v)}>{v.companyName}</p>
                            )
                        })
                    }
                </div>
                <p className="loading-tips">{this.state.loadOver ? '没有更多数据' : ((this.page > 1 || state.list.length > 0) ? '数据加载中...' : '')}</p>
            </section>
        )
    }

    // 获取数据
    private async getData() { 
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/company/company-list`,
            method: 'post',
            data: {
                page: this.page,
                pageSize: 20,
                name: this.state.keyword
            }
        });
        if (r.error_code === 0) { 
            this.isLoading = false;
            const loadOver = r.data.pageNo >= r.data.pages;
            this.setState({
                list: [...this.state.list, ...r.data.resultList],
                loadOver
            });
        }
    }

    /**
     * 加载更多
     * 滚动加载更多数据
     */
    private scrollAction() {
        if (this.isLoading || this.state.loadOver) { 
            return;
        }
        
        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {
            if (this.loadTimer) { 
                clearTimeout(this.loadTimer);
            }
            this.loadTimer = setTimeout(() => {
                this.loadMore();
             }, 500);
        }
    }

    // 加载更多文章内容
    private loadMore() { 
        this.isLoading = true;
        this.page++;
        this.getData();
    }

    // 搜索
    private searchAction() { 
        this.setState({
            keyword: (event as any).target.value
        });
    }

    // 搜索框输入
    private searchKeyDownAction() { 
        if ((event as any).keyCode === 13) { 
            this.searchStartAction();
        }
    }

    // 搜索
    private searchStartAction() { 
        this.isLoading = false;
        this.page = 1;
        this.setState({
            list: [],
            loadOver: false
        }, () => { 
                this.getData();
        });
    }

    // 重置
    private resetAction() { 
        this.isLoading = false;
        this.page = 1;
        this.setState({
            keyword: '',
            list: [],
            loadOver: false
        });
    }

    /**
     * 选择
     * @param item {any} 数据项
     */
    private selectAction(item: any) { 
        if (this.state.type === 2) {
            store.dispatch({
                type: FormulaStore.types.CONCAT,
                concatData: {
                    supplier: item.companyId,
                    supplierName: item.companyName,
                    supplierAbbreviation: item.companyShortName || '',
                }
            });
        } else { 
            store.dispatch({
                type: ProductEditStore.types.CONCAT,
                concatData: {
                    munufacturer_id: item.companyId,
                    munufacturer_name: item.companyName,
                    munufacturer_abbreviation: item.companyShortName || '',
                }
            });
        }
        this.props.history.goBack();
    }
}